module.exports = __webpack_public_path__ + "img/product_1.ffc8a288.png";